import _matchRoutes from './matchRoutes';
export { _matchRoutes as matchRoutes };
import _renderRoutes from './renderRoutes';
export { _renderRoutes as renderRoutes };


//////////////////
// WEBPACK FOOTER
// ./~/react-router-config/es/index.js
// module id = 382
// module chunks = 0